module.exports = __webpack_public_path__ + "static/hero-3f873f8a5ddea81062dd0206bea1daf1.png";